import React from "react";
import { TierOptions } from "shared/AllDropDownOptions";
import { CustomDropDown } from "shared/AllInputs";
import { CustomViewInput } from "shared/AllViewInputs";
import CustomButton from "shared/CustomButton";
import { HandleAdd } from "utils/TableFunctions";
import AddCentralizedHeatingDeductionTable from "views/RentSetup/Tables/AddCentralizedHeatingDeductionTable";
import AddHeatingCostTable from "views/RentSetup/Tables/AddHeatingCostTable";
import ViewHeatingCostTable from "../Tables/ViewHeatingCostTable";
import ViewCentralizedHeatingDeductionTable from "../Tables/ViewCentralizedHeatingDeductionTable";
import { initalAllHeatingCostsInputs } from "../RentSetupForms/initialInputObjects";
import { getTierName } from "./functions";
const HeatingCost = ({ type, data, handleChange, allHeatingCosts, setAllHeatingCosts, allHeatingDeductionCosts, setAllHeatingDeductionCosts }) => {

    const header = (
        <div className="flex flex-wrap justify-content-between w-full">
            <CustomDropDown
                data={data}
                name="tier"
                options={TierOptions}
                ignoreLabel
                extraClassName="px-0 w-10rem"
                col={3}
                className=" w-full "
                onChange={({ name, value }) => handleChange({ name: name, value: value, form: "heating" })}
            />
            <div className="flex justify-content-end flex-wrap">
                <CustomButton
                    type="button"
                    label="Add"
                    onClick={() => HandleAdd(initalAllHeatingCostsInputs, allHeatingCosts, setAllHeatingCosts)}
                />
            </div>
        </div>
    );

    const viewHeader = (
        <div className="flex justify-content-between w-full">
            <CustomViewInput
                value={getTierName(data?.tier)}
                name="tier"
                ignoreLabel
                className="lg:w-20rem"
                col={12}
            />
        </div>
    );

    return (
        <>
            {type === "View" ? <>
                <ViewHeatingCostTable header={viewHeader} allValues={allHeatingCosts} setAllValues={setAllHeatingCosts} />
                <br />
                <ViewCentralizedHeatingDeductionTable title={"Centralized Heating Deduction"} allValues={allHeatingDeductionCosts} setAllValues={setAllHeatingDeductionCosts} />
            </> : <>
                <AddHeatingCostTable customHeader={header} allValues={allHeatingCosts} setAllValues={setAllHeatingCosts} />
                <br />
                <AddCentralizedHeatingDeductionTable allValues={allHeatingDeductionCosts} setAllValues={setAllHeatingDeductionCosts} />
            </>}
        </>
    );
};

export default HeatingCost;
